var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroPivotalFaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 83,
    viewBox: "0 0 106 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2462_770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.8937 0.577637L86.4805 2.99868L39.0694 50.5769L15.9239 29.4028L0.417969 47.3533L40.1361 83.0001L105.6 17.3377L88.8937 0.577637ZM88.8937 10.2618L95.9467 17.3377L39.8827 73.5835L9.99084 46.738L16.4972 39.1939L39.2828 60.0336L88.8937 10.2618Z",
    fill: "#3F81BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2462_770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 83,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroPivotalFaceIcon);
export default __webpack_public_path__ + "static/media/intro_pivotal_face_icon.a288886f959fa844c9bd261248de3cc9.svg";
export { ForwardRef as ReactComponent };